import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import BusinessBlock from "../components/BusinessBlock";
import ServiceBlock from "../components/ServiceBlock";
import CaptureSection from "../components/CaptionSection";
import logo from "../images/logo.png";
import construction from "../images/bigstock-Construction.png";
import bigstock from "../images/bigstock-c.png";
import Slide from "react-reveal/Slide";
import Fade from "react-reveal/Fade";
import Footer from "../components/Layout/Footer";
import Slider from "react-slick";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { Typeahead } from "react-bootstrap-typeahead";
import { Navbar, Nav, Spinner, Col, Row, Alert, Modal } from "react-bootstrap";
import { UserContext } from "../components/UserContext";
import CustomHelmet from "../components/CustomHelmet";
import OverLay from "../components/Layout/OverLay";
import axios from "axios";

const url = "https://www.hubsquares.com/php_files/fetchHomeListing.php/";
const urlAll = "https://www.hubsquares.com/php_files/fetchLisiting.php/";
const increaseUrl = "https://www.hubsquares.com/php_files/processAnalytic.php/";
const NewletterUrl =
  "https://www.hubsquares.com/php_files/processNewsletter.php/";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "#D40C12",
        borderRadius: 16,
        marginRight: "12px",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "none",
        background: "#D40C12",
        borderRadius: 16,
        marginLeft: "4px",
      }}
      onClick={onClick}
    />
  );
}
export default function Home(props) {
  const settings = {
    className: "center",
    infinite: true,
    centerPadding: "0px",
    slidesToShow: 5,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 2000,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          // initialSlide: 3
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const bannerSettings = {
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
  };
  const [city, setCity] = useState("");
  const [service, setService] = useState([]);
  const [listing, setListings] = useState([]);
  const [listings, setAllListings] = useState([]);
  const [show, setShow] = useState(false);
  const [multiple] = useState(false);
  const allservices = [
    "Food and drinks Hub",
    "Catering and Restaurants Hub",
    "Hair products and Hair styling Hub",
    "Makeup and Skincare Hub",
    "Automobile Services",
    "Photography Hub",
    "Fabrics and Tailoring Hub",
    "Courier services Hub",
    "Event planners Hub",
    "Educational Services Hub",
    "Art and Crafts Hub",
    "Books and Authors Hub",
    "Property and Accommodation Hub",
    "Laundry and Cleaning Services Hub",
    "Fashion and Accessories Hub",
    "Tech and Electronics Hub",
    "Health and fitness Hub",
    "Home and decor Hub",
    "Gifting and personal shopping Hub",
    "Legal Services Hub",
    "Accounting Services Hub",
  ];
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [emailName, setEmailName] = useState("");

  const [spin, setSpin] = useState(false);
  const [error, setError] = useState(false);
  const [errorValue, setErrorValue] = useState("");
  const user = useContext(UserContext);
  function logOut() {
    user.setUser(null);
    localStorage.removeItem("access_token");
  }
  function increaseCounter(ref) {
    axios.post(increaseUrl, { refID: ref });
  }
  useEffect(() => {
    const fetchListing = async () => {
      await axios.get(url).then((res) => {
        if (res.data.listing) setListings(res.data.listing);
        setLoading(false);
      });
    };
    const fetchAllListing = async () => {
      await axios.get(urlAll).then((res) => {
        if (res.data.listing) {
          let approvedList = res.data.listing.filter(
            (lis) => lis.status === "approved"
          );
          setAllListings(approvedList);
        }
      });
    };
    fetchAllListing();
    fetchListing();
    setTimeout(() => {
      setShow(true);
    }, 3000);
  }, []);

  function onSearchSubmit() {
    if (service.length > 0 && city.length > 0) {
      props.history.push(`/listing/service=${service[0]}&city=${city}`);
    } else if (service.length > 0 && city.length < 1) {
      props.history.push(`/listing/service=${service[0]}`);
    } else if (service.length < 1 && city.length > 0) {
      props.history.push(`/listing/service=${" "}&city=${city}`);
    }
  }

  async function handleNewsletter(e) {
    if (email) {
      e.preventDefault();
      setSpin(true);
      await axios
        .post(NewletterUrl, {
          email: email,
          subscribe: true,
          firstname: emailName,
        })
        .then(({ data }) => {
          if (data.success === 1) {
            setErrorValue(data.msg);
            setError(true);
            setEmail("");
            setEmailName("");
            setSpin(false);
          } else if (data.success === 0) {
            setErrorValue(data.msg);
            setError(true);
            setSpin(false);
          }
        });
    }
  }
  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError(false);
        setErrorValue("");
      }, 4000);
    }
  }, [error]);

  return (
    <div className="overflow-hidden">
      <CustomHelmet page="Home" />
      <div className="navv">
        <Navbar
          collapseOnSelect
          className="navbar-light"
          expand="lg"
          variant="dark"
        >
          <div className="container">
            <Link className="navbar-brand" to="/">
              <img src={logo} alt="logo" />
            </Link>
            <Navbar.Toggle
              aria-controls="responsive-navbar-nav"
              className="bg-black"
            />
            <Navbar.Collapse
              className="mw-3  justify-content-end"
              id="responsive-navbar-nav"
            >
              <Nav>
                <li className="nav-item position-relative">
                  {props.user ? (
                    <OverLay user={props.user} logOut={logOut} />
                  ) : (
                    <span className="d-flex align-items-center">
                      <Link className="nav-link black-text" to="/register">
                        {/* <i className="fal fa-user-circle black-text"></i> */}
                        Join Now
                      </Link>
                      <span className="mx-0">/</span>
                      <Link className="nav-link black-text" to="/login">
                        Login
                      </Link>
                    </span>
                  )}
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/packages">
                    <button className="addbtn btn btn-danger btn-lg">
                      {/* <i className="fa fa-plus p-0"></i> */}
                      <span>View Packages</span>
                    </button>
                  </Link>
                </li>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Navbar>
      </div>
      <div className="navv position-relative">
        <div className="overlay mh-35rem">
          <div className="banner">
            <div className="content container">
              <h1>Explore HubSquares</h1>
              <p>
                Search, Explore and Discover African Brands, Products and
                Services near you with just a few clicks!
              </p>
              <div className="container">
                <div className="row justify-content-center">
                  <div className="row">
                    <div className="col-md-9 ml-0 col-sm-12 row">
                      <div className="col-md-6 home-search p-0">
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <div className="input-group-text bg-white bod-left-rad">
                              what
                            </div>
                          </div>

                          <Typeahead
                            id="basic-typeahead-example"
                            labelKey="name"
                            className="form-control border-left-0 p-0 typehead form-control-lg input_1"
                            style={{ border: "none" }}
                            onChange={setService}
                            multiple={multiple}
                            options={allservices.sort((item1, item2) =>
                              item1 > item2 ? 1 : -1
                            )}
                            placeholder="Choose a service"
                            selected={service}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 home-search  p-0">
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <div className="input-group-text bg-white rounded-0">
                              where
                              <i
                                className="fa fa-map-marker ml-1"
                                aria-hidden="true"
                              ></i>
                            </div>
                          </div>
                          <input
                            type="text"
                            className="form-control border-left-0 form-control-lg input_2"
                            placeholder="Your City..."
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-12 d-flex justify-content-center mt-md-0 mt-lg-0 mt-2">
                      <button
                        onClick={onSearchSubmit}
                        className="btn btn-danger btn-lg addbtn w-100 justify-content-center"
                      >
                        <i className="fal fa-search"></i>
                        <span>Search</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Slider {...bannerSettings}>
          <div className="wrapper mh-35rem banner1"></div>
          <div className="wrapper mh-35rem banner2"></div>
          <div className="wrapper mh-35rem banner3"></div>
        </Slider>
      </div>

      <main>
        <div className="my-5 slider-con container w-100">
          <Slider {...settings}>
            {allservices.map((lis) => (
              <div key={lis} className="slider-co">
                <ServiceBlock
                  service={lis}
                  title={lis}
                  num={listings.filter((s) => s.category === lis).length}
                  props={props}
                />
              </div>
            ))}
          </Slider>
        </div>
        <div className="container">
          <div className="get_started justify-content-center row mt-5">
            <div className="col-md-6">
              <Slide left>
                <img src={bigstock} width="100%" alt="hubsquares" />
              </Slide>
            </div>
            <div className="col-md-6">
              <Slide right>
                <h2 className="mb-3">
                  Hubsquares is the Largest Online Platform for African
                  Businesses in Diaspora.
                </h2>
                <p>
                  Our goal is to increase visibility of African owned businesses
                  in diaspora and help you easily connect with African
                  businesses near you. All listed businesses on Hubsquares are
                  verified.
                </p>
                <Link to="/register">
                  <button className="btn btn-danger btn-lg addbtn">
                    Get Started
                  </button>
                </Link>
              </Slide>
            </div>
          </div>
        </div>
        <div className="offering mt-5 container">
          <h2 className="text-center">Recently added businesses</h2>
          <p className="text-center">
            Find below recently added businesses near you.
          </p>
          {
            <div className="row my-5 align-items-center justify-content-center">
              {listing.length === 0 && !loading && (
                <h3>No Business Available.</h3>
              )}
            </div>
          }
          <div className="row flex-column my-5 align-items-center justify-content-center">
            {!loading ? (
              <div className="row align-items-center container-sm justify-content-center">
                {listing.map((business, i) => (
                  <div key={i} className="col-md-4 mb-4 mw-290 col-sm-12">
                    <div className="text-dark">
                      <BusinessBlock
                        increaseCounter={() => increaseCounter(business.refID)}
                        title={business.title}
                        rating={business.rating}
                        ratingNumber=""
                        refID={business.refID}
                        to={`/listing-details/${business.refID}`}
                        category={business.category}
                        details={business.googleaddress}
                        img={`https://www.hubsquares.com/php_files/covers/${business.cover}`}
                        city={
                          business.package !== "Basic plan"
                            ? business.phone
                            : "Hidden"
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <>
                {" "}
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
                <br />
              </>
            )}
            {!loading && (
              <div>
                <Link to="/listing">
                  <button className="btn btn-danger btn-lg addbtn">
                    View More
                  </button>
                </Link>
              </div>
            )}
          </div>
        </div>

        <Fade bottom>
          <div className="sign_up my-5 position-relative">
            <div className="overlay"></div>
            <img
              src={construction}
              width="100%"
              height="100%"
              alt="construction"
              className="d-none d-md-block"
            />
            <div className="position-absolute d-flex px-2 justify-content-center align-items-center construction">
              <h1 className="text-center">Our Packages</h1>
              <p className="text-center">
                With our simple and straight forward registration, you can get
                your business listed on our platform in minutes
              </p>
              <Link to="/packages">
                <button className="btn btn-danger btn-lg addbtn">
                  Get Started
                </button>
              </Link>
            </div>
          </div>
        </Fade>
        <CaptureSection home={true} />
        {/* <div className="business container my-3">
          <div className="row align-items-center justify-content-center">
            <div className="col-md-3 mb-3 col-sm-6 flex-column d-flex align-items-center justify-content-center">
              <h2>Recently added Businesses</h2>
              <p>
                Do you have a project and you need verified experts to help you
                execute them? Go through our directory and search for the
                perfect Freelancer.
              </p>

              <div className="d-flex justify-content-start arrowContainer">
                <span className="arrow mr-2">
                  <i
                    className="fa fa-arrow-left text-white p-1"
                    aria-hidden="true"
                  ></i>
                </span>
                <span className="arrow">
                  <i
                    className="fa fa-arrow-right text-white p-1"
                    aria-hidden="true"
                  ></i>
                </span>
              </div>
            </div>
            <AdvertSection
              img={business1}
              company="Klinsheet Consulting Limited"
            />
            <AdvertSection
              img={business2}
              company="Okinawai Tax Consultancy Ltd"
            />
            <AdvertSection
              img={business3}
              company="Abitech Mobile Solutions Company"
            />
          </div>
        </div> */}
        <div id="section1" className="jumbotron mb-0">
          <Row className="py-5">
            <Col md={5} className="text-center">
              <h4>
                Subscribe to our newsletter for notifications of new business
                near you
              </h4>
            </Col>
            <Col md={7}>
              <form>
                <Row className="justify-content-center">
                  <Col md={8}>
                    <div className="form-group">
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="form-control full-width form-control-lg"
                        placeholder="Email"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="text"
                        value={emailName}
                        onChange={(e) => setEmailName(e.target.value)}
                        className="form-control full-width form-control-lg"
                        placeholder="Name"
                        required
                      />
                    </div>
                  </Col>
                  <Col
                    className="d-flex justify-content-center align-items-center"
                    md={4}
                  >
                    <button
                      type="submit"
                      className="btn btn-danger btn-lg addbtn"
                      onClick={(e) => handleNewsletter(e)}
                    >
                      Submit
                      {spin && (
                        <Spinner
                          as="span"
                          animation="grow"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                    </button>
                  </Col>
                </Row>
              </form>
              {error && (
                <Fade bottom collapse when={error}>
                  <Alert
                    variant={
                      errorValue ===
                      "You have successfully subscribed to our newsletter"
                        ? "success"
                        : "danger"
                    }
                  >
                    {errorValue}
                  </Alert>
                </Fade>
              )}
            </Col>
          </Row>
        </div>
        <Modal
          show={show}
          centered
          onHide={() => setShow(false)}
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title className="text-red modal-font-family">
              Newsletter
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="d-flex justify-content-center align-items-center">
            <div className="text-center modal-font-family">
              {/* <img src={logo} className="m-auto" alt="logo" /> */}
              <h4 className="mb-3 modal-font-family">
                Hello! Subscribe to our newsletter and get notified when new
                African businesses register near you
              </h4>
              <div>
                <form>
                  <Row className="justify-content-center">
                    <Col md={8}>
                      <div className="form-group">
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="form-control modal-font-family full-width form-control-lg"
                          placeholder="Email"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          value={emailName}
                          onChange={(e) => setEmailName(e.target.value)}
                          className="form-control modal-font-family full-width form-control-lg"
                          placeholder="Name"
                          required
                        />
                      </div>
                    </Col>
                    <Col
                      className="d-flex justify-content-center align-items-center"
                      md={4}
                    >
                      <button
                        type="submit"
                        className="btn btn-danger btn-lg addbtn"
                        onClick={(e) => handleNewsletter(e)}
                      >
                        Submit
                        {spin && (
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                      </button>
                    </Col>
                  </Row>
                </form>
                {error && (
                  <Fade bottom collapse when={error}>
                    <Alert
                      variant={
                        errorValue ===
                        "You have successfully subscribed to our newsletter"
                          ? "success"
                          : "danger"
                      }
                    >
                      {errorValue}
                    </Alert>
                  </Fade>
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </main>
      <Footer style={{ marginTop: "0" }} />
    </div>
  );
}
